import { FC } from "react";
import styled from "@emotion/styled";
import PasswordRequirements from "@components/PasswordRequirements/PasswordRequirements";
import { MultipleFieldErrors } from "react-hook-form";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomLabelInput from "@components/CustomLabelInput";
import PassportInput from "@components/PassportInput";

const PasswordRequirementsContainer = styled.div`
  margin-top: 24px;
`;

const PASSWORD_VALIDATORS = {
  required: (password: string) => password?.trim().length > 0,
  length: (password: string) => password?.trim().length >= 8,
  number: (password: string) => password?.search(/\d/) >= 0,
  uppercase: (password: string) => password?.search(/[A-Z]/) >= 0,
  lowercase: (password: string) => password?.search(/[a-z]/) >= 0,
  specialCharacter: (password: string) =>
    password?.search(/(?=.*[!@#$%^&*])/) >= 0,
};

export interface PasswordFieldFormType {
  password: string;
}

const PasswordField: FC<{
  form: UseFormReturn<PasswordFieldFormType>;
}> = ({
  form: {
    register,
    getValues,
    formState: { errors },
  },
}) => {
  const { t } = useTranslation();

  return (
    <>
      <CustomLabelInput
        label={t("resetPassword.passwordInput.label")}
        id="password"
      >
        <PassportInput
          {...register("password", {
            validate: PASSWORD_VALIDATORS,
          })}
          id="password"
          error={!!errors.password}
          type="password"
          size="small"
          variant="outlined"
          fullWidth
          placeholder={t("resetPassword.passwordInput.placeholder")}
        />
      </CustomLabelInput>

      <PasswordRequirementsContainer>
        <PasswordRequirements
          empty={!getValues("password")}
          errors={errors.password?.types as MultipleFieldErrors}
        />
      </PasswordRequirementsContainer>
    </>
  );
};

export default PasswordField;
